'use strict';

class AvatarLoader {
    constructor(callback) {
        this.callback = callback;
        this.loader = new THREE.FBXLoader();
    }

    async load(path) {
        try {
            let self = this;

            self.loader.load(path, function (object) {
                if (self.callback) {
                    self.callback(object);
                }

            }, undefined, printError);
        } catch (error) {
            console.error(error);
        }
    }
}

export default AvatarLoader;